import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Droplets, Minus, Plus } from "lucide-react";

const GLASS_ML = 250;

export default function WaterTracker({ ml, goalMl, onDelta }) {
  const goalGlasses = Math.max(1, Math.round((goalMl || 3000) / GLASS_ML));
  const filled = Math.max(0, Math.round((ml || 0) / GLASS_ML));

  return (
    <Card className="border-0 shadow-md" data-testid="water-tracker-card">
      <CardContent className="p-4 sm:p-5">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Droplets className="w-5 h-5 text-sky-500" />
            <h3 className="font-semibold text-gray-900 dark:text-white">Water</h3>
          </div>
          <div className="text-sm tabular-nums text-gray-600 dark:text-gray-400">
            <span className="font-bold text-sky-600">{ml || 0}</span>
            <span className="text-gray-400"> / {goalMl || 3000} ml</span>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <Button
            size="icon"
            variant="outline"
            onClick={() => onDelta(-GLASS_ML)}
            className="h-9 w-9 shrink-0"
            data-testid="water-minus-btn"
          >
            <Minus className="w-4 h-4" />
          </Button>

          <div className="flex-1 flex items-center gap-1 flex-wrap min-w-0">
            {Array.from({ length: goalGlasses }).map((_, i) => {
              const isFilled = i < filled;
              return (
                <button
                  key={i}
                  type="button"
                  onClick={() => onDelta(isFilled ? -GLASS_ML : GLASS_ML)}
                  className={`transition-all active:scale-90 rounded-md p-0.5 ${
                    isFilled ? "text-sky-500" : "text-gray-300 dark:text-gray-600"
                  }`}
                  title={`${(i + 1) * GLASS_ML} ml`}
                  data-testid={`water-glass-${i}`}
                >
                  <Droplets className="w-5 h-5 sm:w-6 sm:h-6 fill-current" />
                </button>
              );
            })}
          </div>

          <Button
            size="icon"
            onClick={() => onDelta(GLASS_ML)}
            className="h-9 w-9 shrink-0 bg-sky-500 hover:bg-sky-600"
            data-testid="water-plus-btn"
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>

        <p className="text-[11px] text-gray-500 mt-2">Each glass = {GLASS_ML} ml. Tap a glass or use +/−.</p>
      </CardContent>
    </Card>
  );
}
